import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languageNameFor, useUiLanguage } from '@/features/chat-trf/language';


interface Props {
  viewerLanguage: string;
  otherPartyLanguage: string;
  otherPartyName: string;
  disclosureMode: 'banner+chip' | 'chip-only';
}

export function ThreadTranslationBanner({
  viewerLanguage, otherPartyLanguage, otherPartyName, disclosureMode,
}: Props) {
  const { t } = useTranslation(['chat', 'common']);
  const uiLanguage = useUiLanguage();
  const [collapsed, setCollapsed] = useState(false);

  if (disclosureMode === 'chip-only') return null;
  if (viewerLanguage === otherPartyLanguage) return null;

  if (collapsed) {
    return (
      <div className="text-caption px-3 py-1 bg-muted border-b text-stevens-ink-3">
        {t('handoff.translation.bannerCollapsed')}
      </div>
    );
  }

  return (
    <div className="relative bg-stevens-bg-3 border-b border-stevens-rule p-3 text-body">
      <div className="font-medium pr-16">
        {'🌐 '}
        {t('handoff.translation.bannerTitle', { name: otherPartyName })}
      </div>
      <div className="text-stevens-ink-3 mt-1">
        {t('handoff.translation.bannerDirections', {
          theirs: languageNameFor(viewerLanguage, uiLanguage),
          yours: languageNameFor(otherPartyLanguage, uiLanguage),
        })}
      </div>
      <div className="text-caption text-stevens-ink-3 mt-1">
        {t('handoff.translation.bannerNote')}
      </div>
      <button
        type="button"
        onClick={() => setCollapsed(true)}
        aria-label={t('common:actions.dismiss')}
        className="absolute right-3 top-3 text-caption text-stevens-ink-3 hover:text-foreground transition-colors"
      >
        {t('common:actions.dismiss')}
      </button>
    </div>
  );
}
